module.exports = __webpack_public_path__ + "static/media/bronzeTop3M.29042a62.webp";